import React from 'react';
import HeroSectionMain from '../components/HeroSectionMain/HeroSectionMain';
import PartnersLogoBar from '../components/PartnersLogoBar/PartnersLogoBar';
import './Home.css';
import AboutUs from '../components/AboutUs/AboutUs';
import OurSolution from '../components/OurSolution/OurSolution';
import WeServe from '../components/WeServe/Weserve';
import Getstarted from '../components/Getstarted/Getstarted';
import SEO from '../components/SEO/SEO';
import { OrganizationSchema, LocalBusinessSchema, WebSiteSchema } from '../components/SEO/StructuredData';

function Home(): JSX.Element {
  return (
    <main className="page home-page">
       <SEO title="Home" description="Cool & Care - Your trusted partner for IT security, HVAC, fire safety, solar solutions and software development in DRC." keywords="Cool and Care, IT solutions, HVAC, fire safety, CCTV, solar energy, software development, DRC, Kinshasa" />
      <WebSiteSchema />
      <OrganizationSchema />
      <LocalBusinessSchema />
      <HeroSectionMain />
      {/* <ServicesSection /> */}
      <OurSolution/>
      <AboutUs />
      <PartnersLogoBar />
      <WeServe/>
      <Getstarted/>
      {/* <StatisticsSection /> */}
      {/* <GallerySection /> */}
      {/* <ContactSection /> */}
    </main>
  );
}

export default Home;
